import { createContext, ReactNode, useMemo } from 'react';
import { useNullableContext } from 'shared/hooks/useNullableContext';
import { UpdateParams, useLocationParams } from 'shared/routing/LocationParams';

import {
  ReportsInvoicesParamsDTO,
  reportsInvoicesParamsSchema,
} from './ReportsDTO';

interface ReportsInvoicesContext {
  params: ReportsInvoicesParamsDTO;
  setParams: UpdateParams<ReportsInvoicesParamsDTO>;
}

const Context = createContext<null | ReportsInvoicesContext>(null);

export function useReportsInvoicesContext() {
  return useNullableContext('ReportsInvoices', Context);
}

interface Props {
  children?: ReactNode;
}

export function ReportsInvoicesContextProvider({ children }: Props) {
  const [params, setParams] = useLocationParams<ReportsInvoicesParamsDTO>({
    zodSchema: reportsInvoicesParamsSchema,
    persistName: 'ReportsInvoices',
  });

  const ctx = useMemo<ReportsInvoicesContext>(
    () => ({ params, setParams }),
    [params, setParams],
  );

  return <Context.Provider value={ctx}>{children}</Context.Provider>;
}
